// extracted by mini-css-extract-plugin
export default {"galleryItem":"c-p_fE","galleryItem_borderTopRadius":"c-p_fF","galleryItem__image":"c-p_fG"};